import { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { auth } from '../../firebase';

/**
 * Custom hook: useOAuthSignIn
 * @description Handles Firebase OAuth sign-in with any provider robustly.
 *
 * @param {Object} provider - The Firebase Auth provider (e.g., GoogleAuthProvider, OAuthProvider).
 * @returns {Object} - An object containing `signIn` function and `isSigningIn` state.
 */
export const useOAuthSignIn = (provider) => {
  const [isSigningIn, setIsSigningIn] = useState(false);

  const signIn = async () => {
    if (isSigningIn) return;

    setIsSigningIn(true);

    try {
      const result = await signInWithPopup(auth, provider);
      return result.user; // Returns the authenticated user
    } catch (error) {
      if (error.code === 'auth/popup-closed-by-user') {
        console.warn('Sign-in popup was closed by the user.');
      } else {
        console.error('OAuth Sign-In Error:', error.message);
      }
      throw error; // Rethrow the error so it can be handled by the calling component
    } finally {
      setIsSigningIn(false); // Ensure the state is reset
    }
  };

  return { signIn, isSigningIn };
};
